/**
 * The "Supported languages and frameworks" dialog, opened from anywhere ("What can Flow run?" links, ⌘K): a tiny store
 * that the one SupportedStacksHost (mounted by the app) follows. `openSupportedStacks(stack)` says false when no host
 * is mounted, so the caller goes to the page (/supported-stacks) instead.
 */
const listeners = new Set();
let state = { open: false, opened: false, stack: null };

function set(next) {
  state = { ...state, ...next };
  listeners.forEach((listener) => listener());
}

/** Opens the dialog, pointing at `stack` (a row id) if given; false when nothing can show it. */
export function openSupportedStacks(stack = null) {
  if (!listeners.size) { return false; }
  set({ open: true, opened: true, stack: stack || null });
  return true;
}

export function closeSupportedStacks() { set({ open: false }); }

export function subscribeSupportedStacks(listener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export const supportedStacksState = () => state;
